import { render, staticRenderFns } from "./Apoyo.vue?vue&type=template&id=228e98c7&"
import script from "./Apoyo.vue?vue&type=script&lang=js&"
export * from "./Apoyo.vue?vue&type=script&lang=js&"
import style0 from "./Apoyo.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports